<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="large"
            @close="close"
			>
            <template slot="header">
                <h5 class="mb-0">{{ $t('Feature List on') }} {{packageName}}</h5>
            </template>
            <template slot="body">
				<div class="table-menu flex-center">
					<div>
						<button
							class="btn btn-submit btn-default" :class="{'disabled': features.length >= 7}"
							@click="addItem">
							{{ $t('Add Features') }}
						</button>
					</div>
				</div>
				<!-- Loader -->
				<div class="p-5 text-center" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<!-- main List -->
				<div id="styleScroll2" class="list-group list-feature-wrapper">
					<draggable v-model="features" @change="onListChange" v-if="features.length > 0" v-bind="dragOptions">
						<transition-group type="transition">
							<div v-for="item in features" :key="item.id">
								<div @click="editItem(item)">
									<a class="list-group-item text-decoration-none pointer">
										<div class="d-flex justify-content-between">
											<h5>{{ item.feature_name }}</h5>
											<div class="d-flex">
												<div @click="editItem(item)">
													<mdIcon class="feature-icon-edit" v-tooltip="'Edit'">edit</mdIcon>
												</div>
												<div @click.stop="confirmRemoveItem(item)">
													<mdIcon  class="feature-icon-delete" v-tooltip="'Delete'">cancel</mdIcon>
												</div>
											</div>
										</div>
										<div>
											<label class="text-secondary" v-if="item.feature_id !== 6">{{ $t('Limit') }}: </label><label v-if="item.feature_id !== 6" class="mr-3 ml-1">{{ item.limit }}</label>
											<label class="text-secondary" v-if="item.feature_id !== 6">{{ $t('Limit Type') }}:</label><label v-if="item.feature_id !== 6" class="mr-3 ml-1">{{ item.limit_type }}</label>
											<label class="text-secondary" v-if="item.is_enabled">{{ $t('Status') }}:</label><label class="mr-3 ml-1" v-if="item.is_enabled">{{ $t('Enabled') }}</label>
											<label class="text-secondary" v-if="!item.is_enabled">{{ $t('Status') }}:</label><label class="mr-3 ml-1" v-if="!item.is_enabled">{{ $t('Disabled') }}</label>
											<label class="text-secondary" v-if="item.upload_size && item.limit_type === 'storage'">{{ $t('Upload Size') }}:</label><label class="mr-3 ml-1" v-if="item.upload_size && item.limit_type === 'storage'">{{ item.upload_size }}</label>
										</div>
									</a>
								</div>
							</div>
						</transition-group>
					</draggable>
					<div v-if="!isFetching && features.length === 0" class="text-center">
						{{ $t('You have not added any Features yet') }}
					</div>
				</div>
				<div class="absolute text-right btn-apply-feature">
					<button v-if="features.length > 0"
						@click="applyToAllUsers"
						class="btn btn-submit btn-primary mt-3 mr-4"
						:class="{ 'is-loading': isSavingAllUser }">
						{{ $t('Apply to all user') }}
					</button>
				</div>
            </template>
            <div slot="footer" class="text-center">
				<div class="mt-2"></div>
            </div>
		</modal>
		<!-- Modals -->
		<div class="modals">
			<!-- Package Features Form -->
			<package-features-form
				:packageId="packageId"
				:newPackageId="newPackageId"
				:data="selected"
				:featuresFromParent="features"
				@saved="insertItem"
				@close="closeModalFeature"
				v-if="isFeatureFormVisible || (isNewPackage && dataPackage.type !== 'non_feature')"
			/>
			<!-- Delete Confirmation -->
			<modal
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					<h3>{{ $t('Remove Package Feature') }}</h3>
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ selected.feature_name }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>

import draggable from 'vuedraggable';
import Modal from '@/components/Modal.vue';
import PackageFeaturesForm from '@/components/PackageFeaturesForm.vue';
import packageFeaturesApi from '@/api/package-features';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'ModalPackageFeatures',
	components: {
		Modal,
		draggable,
		PackageFeaturesForm,
	},
	props: {
		dataPackage: {
			type: Object,
		},
		isNewPackage: {
			type: Boolean,
		},
		newPackageId: {
			type: Number,
		},
	},
	mounted() {
	},
	data: () => ({
		dragOptions: {
			animation: 100,
		},
		drag: false,
		packageName: '',
		features: [],
		selected: null,
		packageId: null,
		isFeatureFormVisible: false,
		isConfirmRemoveVisible: false,
		isRemoving: false,
		isFetching: false,
		isApplyToAllUser: true,
		isSavingAllUser: false,
	}),
	methods: {
		applyToAllUsers() {
			this.isSavingAllUser = true;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Feature',
					text: message,
				});
				this.isSavingAllUser = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Feature',
					text: message,
				});
				this.isSavingAllUser = false;
			};
			const params = {
				package_id: this.dataPackage.id,
			};
			packageFeaturesApi.applyToAllUser(params, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
		initDataPackage() {
			this.resetDataPackage();
			if (this.dataPackage) {
				this.setDataPackage(this.dataPackage);
			}
		},
		resetDataPackage() {
			this.packageName = '';
		},
		setDataPackage(dataPackage) {
			this.packageName = dataPackage.name;
		},
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.features = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.features = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Packages',
					text: message,
				});
				this.isFetching = false;
			};
			packageFeaturesApi.getList(params, callback, errorCallback);
		},
		insertItem(item) {
			const index = this.features.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.features.push(item);
				this.$emit('resetNewPackage');
			} else {
				this.$set(this.features, index, item);
			}
		},
		closeModalFeature() {
			this.$emit('resetNewPackage');
			this.isFeatureFormVisible = false;
		},
		addItem() {
			this.packageId = this.dataPackage.id;
			this.selected = null;
			this.isFeatureFormVisible = true;
		},
		editItem(item) {
			this.packageId = this.dataPackage.id;
			this.selected = item;
			this.isFeatureFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.features.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.features.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Packages',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Packages',
					text: message,
				});
			};
			packageFeaturesApi.delete(item.id, callback, errorCallback);
		},
		onListChange() {
			this.features.forEach((item, index) => {
				const order = index + 1;
				this.$set(this.features[index], 'order', order);
			});
			const ids = this.features.map(({ id }) => id);
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'Notification',
					type: 'success',
					title: this.$t('Features Items'),
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'Notification',
					type: 'error',
					title: this.$t('Error'),
					text: message,
				});
			};
			packageFeaturesApi.reOrder(ids, callback, errorCallback);
		},
	},
	computed: {
		fetchParams() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'order',
				sort_by: 'asc',
				package_id: this.dataPackage.id,
				// role: this.role,
			};
			return params;
		},
	},
	created() {
		this.initDataPackage();
		this.fetch(true);
	},
};
</script>
